import { render, staticRenderFns } from "./laporantaman.vue?vue&type=template&id=ecebf864&scoped=true&"
import script from "./laporantaman.vue?vue&type=script&lang=js&"
export * from "./laporantaman.vue?vue&type=script&lang=js&"
import style0 from "./laporantaman.vue?vue&type=style&index=0&id=ecebf864&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecebf864",
  null
  
)

export default component.exports